import styled from 'styled-components';
import { layout, media, colorUtils } from '@prisjakt/ui-base';
import { Modal } from '../../../styles';

export const MediumUp = styled.div`
  ${media.smallOnly`
    display: none;
  `};
`;

export const FilterPanelWrapper = styled.div`
  background: ${p => p.theme.bg.secondary};
  padding: ${layout.measurements.spacing100};
  border-radius: 8px;
  width: 100%;
  margin-top: ${layout.measurements.spacing050};
  margin-bottom: ${layout.measurements.spacing050};
  border: 1px solid ${p => p.theme.lines.primary};
  box-shadow: ${p =>
    `0px 2px 8px 0px ${colorUtils.setRgbaAlpha(p.theme.colors.base800, 0.24)}`};
`;

export const FilterPanel = styled.div`
  display: grid;
  gap: ${layout.measurements.spacing050};
  grid-template-columns: 1fr 1fr;
  grid-auto-flow: row;
  width: 100%;

  ${media.mediumDown`
    grid-template-rows: auto;
    grid-auto-flow: row;
    grid-template-columns: 1fr;
  `};
`;

export const FilterOptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0;
`;

export const CheckboxClickarea = styled.div``;

export const StyledModal = styled(Modal)`
  && {
    max-height: 90vh;
    overflow-y: scroll;
  }
`;

export const Header = styled.div`
  margin-bottom: ${layout.measurements.spacing050};

  &:not(:first-child) {
    margin-top: ${layout.measurements.spacing150};
  }
`;
